import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=a23815ae&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23815ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a23815ae')) {
      api.createRecord('a23815ae', component.options)
    } else {
      api.reload('a23815ae', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=a23815ae&scoped=true&", function () {
      api.rerender('a23815ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYR2oHuJ35SY/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports